import { useSnapshot } from 'valtio'
import { Badge, RingBadge } from '@/components/Badge/Badge'
import { state } from '@/lib/state'
import { cn } from '@/lib/utils'
import styles from './RingFilter.module.css'

interface RingFilterProps {
  value?: string
  onChange: (value: string) => void
  className?: string
}

export function RingFilter({ value, onChange, className }: RingFilterProps) {
  const { radarConfig } = useSnapshot(state)
  const rings = radarConfig?.rings || []

  return (
    <ul className={cn(styles.filter, className)}>
      <li>
        <Badge
          size="large"
          selectable
          selected={!value}
          onClick={() => {
            onChange('')
          }}
          data-testid="filter-option-all"
          color={'#777'}
        >
          All
        </Badge>
      </li>
      {rings.map(ring => (
        <li key={ring.id}>
          <RingBadge
            ring={ring.id}
            size="large"
            selectable
            selected={value === ring.id}
            onClick={() => onChange(ring.id)}
            data-testid={`filter-option-${ring.id}`}
          />
        </li>
      ))}
    </ul>
  )
}
